'use strict';
var throttle = require('lodash.throttle');

export default class Banner {
  constructor() {

    const banner = $('.banner');
    if(banner.length) {
      const mobileImages = function(){


        const banner = $('.banner');

        $.each(banner, function(i, ele){

          if($(this).attr('data-image-mobile')){

            if($(this).attr('data-image-mobile').length > 0){

              if ($(window).width() < 480){
                let mobileStyle = $(this).attr('data-image-mobile');
                $(this).attr('style', mobileStyle)
              } else {
                let desktopStyle = $(this).attr('data-image-desktop');
                $(this).attr('style', desktopStyle)
              }


            }
          } else {
              let desktopStyle = $(this).attr('data-image-desktop');
              $(this).attr('style', desktopStyle)
          }

        })
      }


      $(window).on('resize', throttle(mobileImages, 25));
      mobileImages()
    }


  }
}
